import { QuestionComponentProps2, QuestionSolutionProps2 } from './question-component-plugin'

export const QuestionFactorySymbol = Symbol.for("QuestionFactorySymbol");
export type QuestionFactory<TQuestion, TAnswer, TState, TCorrectAnswer, TSolutionAnswer = TAnswer> =
      (questionType: string,
       propsData: QuestionComponentProps2<TQuestion, TAnswer, TState>) => CurrentQuestion<TSolutionAnswer, TCorrectAnswer>

// REVIEW: rename?
export interface CurrentQuestion<TSolutionAnswer, TCorrectAnswer> extends Vue {
  solutionProps?: () => QuestionSolutionProps2<TSolutionAnswer, TCorrectAnswer>;
}

export const QuestionSolutionFactorySymbol = Symbol.for("QuestionSolutionFactorySymbol");
export type QuestionSolutionFactory<TAnswer, TCorrectAnswer> =
      (questionType: string, propsData: QuestionSolutionProps2<TAnswer, TCorrectAnswer>) => Vue;
